module.exports = __webpack_public_path__ + "static/media/hexa_full.f78e76cf.svg";